/**
 * CC Gallery — hero stage + thumbnail rail + click-to-fullsize lightbox
 * Loaded as an external asset (not inline) so it isn't affected by
 * Content-Security-Policy restrictions on inline scripts.
 */
(function () {
  function initGallery(gallery) {
    var lightbox = gallery.nextElementSibling;
    if (!lightbox || !lightbox.hasAttribute('data-cc-lightbox')) {
      console.warn('[cc-gallery] Could not find the matching lightbox for', gallery);
      return;
    }
    if (gallery.dataset.ccInit === 'true') return;
    gallery.dataset.ccInit = 'true';

    // Move the lightbox to be a direct child of <body>. If any ancestor on the
    // page has a transform / filter / contain / will-change property, it becomes
    // the containing block for position:fixed descendants — which breaks a
    // "fixed to the viewport" overlay and traps it inside that ancestor instead.
    // Re-parenting to <body> sidesteps that entirely, regardless of theme/app CSS.
    if (lightbox.parentElement !== document.body) {
      document.body.appendChild(lightbox);
    }

    var stageItems = Array.prototype.slice.call(gallery.querySelectorAll('[data-cc-stage-item]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-cc-thumb]'));
    var currentLabel = gallery.querySelector('[data-cc-current]');
    var lightboxImages = Array.prototype.slice.call(lightbox.querySelectorAll('[data-cc-lightbox-image]'));
    var lightboxCurrent = lightbox.querySelector('[data-cc-lightbox-current]');

    var activeStage = 0;
    var activeLightbox = 0;
    var lastFocused = null;

    function goToStage(index) {
      if (!stageItems.length) return;
      index = (index + stageItems.length) % stageItems.length;
      stageItems.forEach(function (item, i) {
        var isActive = i === index;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
      thumbs.forEach(function (thumb, i) {
        var isActive = i === index;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      if (currentLabel) currentLabel.textContent = index + 1;
      activeStage = index;
    }

    function showLightboxAt(pos) {
      if (!lightboxImages.length) return;
      pos = (pos + lightboxImages.length) % lightboxImages.length;
      lightboxImages.forEach(function (img, i) { img.hidden = i !== pos; });
      if (lightboxCurrent) lightboxCurrent.textContent = pos + 1;
      activeLightbox = pos;
    }

    function openLightboxByMediaIndex(mediaIndex) {
      if (!lightboxImages.length) return;
      lastFocused = document.activeElement;
      var pos = -1;
      lightboxImages.forEach(function (img, i) {
        if (parseInt(img.getAttribute('data-index'), 10) === mediaIndex) pos = i;
      });
      showLightboxAt(pos === -1 ? 0 : pos);
      lightbox.hidden = false;
      requestAnimationFrame(function () { lightbox.classList.add('is-open'); });
      document.body.classList.add('cc-lightbox-lock');
      var closeBtn = lightbox.querySelector('.cc-lightbox__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      document.body.classList.remove('cc-lightbox-lock');
      window.setTimeout(function () { lightbox.hidden = true; }, 220);
      if (lastFocused) lastFocused.focus();
    }

    gallery.addEventListener('click', function (e) {
      var thumbBtn = e.target.closest('[data-cc-thumb]');
      if (thumbBtn) { goToStage(parseInt(thumbBtn.getAttribute('data-index'), 10)); return; }

      var prevBtn = e.target.closest('[data-cc-prev]');
      if (prevBtn) { goToStage(activeStage - 1); return; }

      var nextBtn = e.target.closest('[data-cc-next]');
      if (nextBtn) { goToStage(activeStage + 1); return; }

      var openBtn = e.target.closest('[data-cc-open-lightbox]');
      if (openBtn) { openLightboxByMediaIndex(parseInt(openBtn.getAttribute('data-index'), 10)); return; }
    });

    lightbox.addEventListener('click', function (e) {
      var lbPrev = e.target.closest('[data-cc-lightbox-prev]');
      if (lbPrev) { showLightboxAt(activeLightbox - 1); return; }

      var lbNext = e.target.closest('[data-cc-lightbox-next]');
      if (lbNext) { showLightboxAt(activeLightbox + 1); return; }

      // Any other click inside the lightbox — the image, the dark background,
      // the close button — simply closes it. No dead zones to get stuck on.
      closeLightbox();
    });

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') showLightboxAt(activeLightbox - 1);
      if (e.key === 'ArrowRight') showLightboxAt(activeLightbox + 1);
    }, true);

    // Safety net: if a click ever lands outside the lightbox entirely while
    // it's open (meaning something else on the page still received it instead
    // of the overlay), force-close on that next click too.
    document.addEventListener('click', function (e) {
      if (lightbox.hidden) return;
      var withinLightbox = e.target.closest('[data-cc-lightbox]');
      if (!withinLightbox) closeLightbox();
    }, true);
  }

  function init() {
    var galleries = document.querySelectorAll('[data-cc-gallery]');
    if (!galleries.length) return;
    galleries.forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();